// extracted by mini-css-extract-plugin
export default {"button":"styles_button__AfRI4","icon":"styles_icon__9Cjdh"};